import { Plus, Lock } from "lucide-react";

interface CreateProjectCardProps {
  onClick?: () => void;
  disabled?: boolean;
  projectLimit?: number;
  activeProjectCount?: number;
}

const CreateProjectCard = ({ 
  onClick, 
  disabled = false,
  projectLimit,
  activeProjectCount 
}: CreateProjectCardProps) => {
  const showLimitMessage = disabled && projectLimit !== undefined && activeProjectCount !== undefined;

  return (
    <button
      onClick={onClick}
      className={`group flex flex-col items-center justify-center rounded-2xl border-2 border-dashed p-6 transition-all duration-200 aspect-[4/3] ${
        disabled 
          ? "border-foreground/10 bg-muted/50 cursor-pointer" 
          : "border-foreground/20 bg-background hover:border-accent hover:bg-accent hover:scale-[1.02]"
      }`}
    >
      <div className={`flex h-12 w-12 items-center justify-center rounded-full transition-colors ${
        disabled 
          ? "bg-foreground/5" 
          : "bg-foreground/5 group-hover:bg-foreground/10"
      }`}>
        {disabled ? (
          <Lock className="h-5 w-5 text-foreground/40" />
        ) : (
          <Plus className="h-6 w-6 text-foreground/40 transition-colors group-hover:text-foreground" />
        )}
      </div>
      <span className={`mt-4 font-medium transition-colors ${
        disabled 
          ? "text-foreground/40" 
          : "text-foreground/60 group-hover:text-foreground"
      }`}>
        {disabled ? "Upgrade to Create More" : "Create New Project"}
      </span>
      {showLimitMessage && (
        <span className="mt-1 text-xs text-muted-foreground">
          {activeProjectCount}/{projectLimit} projects used
        </span>
      )}
    </button>
  );
};

export default CreateProjectCard;
